import cx from "classnames";
import type { FC, ReactNode } from "react";

export type ToolbarProps = {
	children?: ReactNode;
	spacing?: "default" | "none";
};

export const ToolbarButton = ({ children }) => {
	return <button>{children}</button>;
};

export const Toolbar: FC<ToolbarProps> = ({ children, spacing = "default" }) => {
	return (
		<div
			className={cx(
				"min-h-8",
				"rounded-lg",
				"bg-primary-raised",
				"border",
				"shadow-lg",
				"p-1",
				"mx-2",
				"-my-2"
			)}
		>
			<div className={cx("flex", "gap-0.5", "items-center")}>{children}</div>
		</div>
	);
};
